import * as React from 'react';
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl';

import { WithStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { createStyles, withStyles, Theme } from '@material-ui/core/styles';


interface Props {
    readonly goals: string,
    readonly mainMessage: string,
    readonly audience: string,
    readonly onGoalsChanged: (goals: string) => void,
    readonly onMainMessageChanged: (mainMessage: string) => void,
    readonly onAudienceChanged: (audience: string) => void,
}

const styles = (theme: Theme) => createStyles({
    root: {
        padding: 4 * theme.spacing.unit,
    },
    subtitle: {
        color: theme.palette.text.secondary,
    },
    textField: {
        marginTop: 30,
        marginBottom: 40,
    },
});

type Styles = 'root' | 'subtitle' | 'textField';


const BasicDataPanel = ({ goals, mainMessage, audience, classes, intl, onGoalsChanged, onMainMessageChanged, onAudienceChanged }:
                            Props & WithStyles<Styles> & InjectedIntlProps) => {
    return (
        <div className={`basic-data-panel-view vbox ${classes.root}`}>
            <Typography variant="h5">
                <FormattedMessage id="basic_data_title"/>
            </Typography>
            <Typography variant="body2" className={classes.subtitle}>
                <FormattedMessage id="basic_data_subtitle"/>
            </Typography>
            <TextField
                id="goals"
                label={intl.formatMessage({id: 'basic_data_goals_label'})}
                className={classes.textField}
                value={goals}
                onChange={event => onGoalsChanged(event.target.value)}
                margin="normal"
                multiline={true}
                fullWidth={true}
                rows={8}
                variant="outlined"
            />
            <TextField
                id="main-message"
                label={intl.formatMessage({id: 'basic_data_main_message_label'})}
                className={classes.textField}
                value={mainMessage}
                onChange={event => onMainMessageChanged(event.target.value)}
                margin="normal"
                multiline={true}
                fullWidth={true}
                rows={8}
                variant="outlined"
            />
            <TextField
                id="audience"
                label={intl.formatMessage({id: 'basic_data_audience_label'})}
                className={classes.textField}
                value={audience}
                onChange={event => onAudienceChanged(event.target.value)}
                margin="normal"
                multiline={true}
                fullWidth={true}
                rows={8}
                variant="outlined"
            />
        </div>
    );
}

export default withStyles(styles)(injectIntl(BasicDataPanel));



// WEBPACK FOOTER //
// ./src/components/BasicDataPanelView.tsx